import { FormControl, FormLabel, Select, Text } from '@chakra-ui/react'
import BasicDateStringPicker from '../../../../../components/BasicDateStringPicker'
import {
  Profile,
  Gender,
  diagnosisTitles,
  Diagnosis,
} from '../../../../../types/FirestoreUser'

interface DemographicsSectionProps {
  profile: Profile
  onUpdate: (changes: Partial<Profile>) => void
  isBirthDateLocked?: boolean
}

const DemographicsSection = ({
  profile,
  onUpdate,
  isBirthDateLocked,
}: DemographicsSectionProps) => {
  return (
    <>
      <FormControl>
        <FormLabel>
          Birth Date{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <BasicDateStringPicker
          startYear='1930'
          endYear={new Date().getFullYear().toString()}
          dateString={profile.birthDate || ''}
          setDateString={(value: string) => onUpdate({ birthDate: value })}
          isDisabled={isBirthDateLocked}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Gender{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Select
          required
          placeholder='Choose Gender'
          defaultValue={profile.gender}
          onChange={(e) => onUpdate({ gender: e.target.value as Gender })}
        >
          <option value='male'>Male</option>
          <option value='female'>Female</option>
          <option value='other'>Other</option>
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>
          Diagnosis{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Select
          required
          placeholder='Choose Diagnosis'
          defaultValue={profile.diagnosis}
          onChange={(e) => onUpdate({ diagnosis: e.target.value as Diagnosis })}
        >
          {[
            'als',
            'pls',
            'als-probable',
            'other',
            'administrator',
            'medical',
            'nonprofit',
          ].map((diagnosis) => (
            <option value={diagnosis} key={diagnosis}>
              {diagnosisTitles[diagnosis as Diagnosis]}
            </option>
          ))}
        </Select>
      </FormControl>

      {/* Empty div for grid spacing */}
      <div></div>
    </>
  )
}

export default DemographicsSection
